import Vue from 'vue';
import Help from '@/components/pages/LandingPage/help';
import BannerMessage from '@/components/pages/LandingPage/bannerMessage';

Vue.component('help', Help);
Vue.component('banner-message', BannerMessage);
